<mat-form-field class="w-100" [appearance]="appearance()">
  <mat-label>{{ label() | translate }}</mat-label>
  <input
    matInput
    [id]="id() ? 'input-' + id() : ''"
    [type]="showPassword ? 'text' : 'password'"
    [placeholder]="placeholder()"
    [formControl]="formControlRef()"
    [required]="required()"
    [attr.autocomplete]="autocomplete()"
  />
  <button
    mat-icon-button
    matSuffix
    (click)="showPassword = !showPassword"
    [attr.aria-label]="'Hide password'"
    [attr.aria-pressed]="showPassword"
    type="button"
    tabindex="-1"
  >
    <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>

  <mat-hint>
    <ng-content select="[slot=hint]"></ng-content>
  </mat-hint>
</mat-form-field>
